<template>
    <div>
        <div class="leaves_top"></div>

        <HeaderMenu_Admin />
        <LateralMenu_Admin />

        <div id="admin-giftcards">
            <div class="content">
                <div class="admin-tools header">
                    <span>Créér un bon cadeau</span>
                    <a v-on:click="createGiftcard_clicked(1)">1</a>
                    <a v-on:click="createGiftcard_clicked(2)">2</a>
                    <a v-on:click="createGiftcard_clicked(3)">3</a>
                    <a v-on:click="createGiftcard_clicked(4)">4</a>
                    <a v-on:click="createGiftcard_clicked(5)">5</a>
                    <a v-on:click="createGiftcards_clicked()">Bons cadeaux par lot</a>
                    <router-link to="/admin/logout" v-slot="{ href }">
                        <a v-bind:href="href">Déconnexion</a>
                    </router-link>
                </div>
            </div>

            <div class="list-container content">
                <span class="title">Liste des bons cadeaux en cours de validité</span>
                <div class="liste-bons-cadeaux">
                    <div>
                        <span>Code</span>
                        <span>Prénom et nom</span>
                        <span>Montant</span>
                        <span>Date de création</span>
                    </div>
                    <div v-for="giftcard in giftcards" v-on:click="giftcardItem_clicked(giftcard)">
                        <span>{{ giftcard.code }}</span>
                        <span>
                            {{ giftcard.first_name }} {{ giftcard.last_name }}
                            <template v-if="giftcard.business_name">&nbsp;({{ giftcard.business_name }})</template>
                        </span>
                        <span>
                            <template v-if="giftcard.amount_type == 'CURRENCY'">{{ giftcard.amount_value }}€</template>
                            <template v-else-if="giftcard.amount_type == 'DISCOUNT'">-{{ giftcard.amount_value }}%</template>
                        </span>
                        <span>{{ giftcard.creation_date }}</span>
                        <div class="tools">
                            <span class="has-expired" title="Ce bon cadeau a expiré" v-if="giftcard.has_expired">&nbsp;</span>
                            <span class="delete" v-on:click="bonsCadeauxItem_onDeleteClicked(giftcard)">&#x274C;</span>
                        </div>
                        <div class="more" v-bind:class="{ 'opened': selectedGiftcard && giftcard.code == selectedGiftcard.code }">
                            <template v-if="giftcard.business_name">
                                Entreprise : {{ giftcard.business_name }}
                                <br />
                            </template>
                            Adresse e-mail : {{ giftcard.email_from }}
                            <br />Téléphone : {{ giftcard.phone_number }}
                            <br />
                                <template v-if="giftcard.code_already_sent">
                                    <span class="icon yes"></span>Le code a été envoyé par e-mail
                                </template>
                                <template v-else>
                                    <span class="icon no"></span>Le code n'a pas été envoyé par e-mail
                                </template>
                            <br />
                                <template v-if="giftcard.code_already_used">
                                    <span class="icon yes"></span>Le code a été utilisé
                                </template>
                                <template v-else>
                                    <span class="icon no"></span>Le code n'a pas été utilisé
                                </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="leaves_sides">
            <div class="left"></div>
            <div class="right"></div>
        </div>

        <BonsCadeaux ref="bonscadeauxPopin" />
        <BonCadeau ref="boncadeauPopin" v-bind:view_paymentDelayed="true" />

        <Footer />
    </div>
</template>

<script>
import HeaderMenu_Admin from '../../components/HeaderMenu_Admin.vue';
import LateralMenu_Admin from '../../components/LateralMenu_Admin.vue';
import Footer from '../../components/Footer.vue';
import BonsCadeaux from '../../components/BonsCadeaux.vue';
import BonCadeau from '../../components/BonCadeau.vue';

import axios from 'axios';

export default {
    name: "Admin_GiftcardsPage",
    components: {
        HeaderMenu_Admin,
        LateralMenu_Admin,
        Footer,
        BonsCadeaux,
        BonCadeau
    },
    data: () => ({
        // giftcards informations
        giftcards: null,
        // processing
        selectedGiftcard: null,
        admin_isProcessing: false
    }),
    methods: {
        redirect: function(url) {
            window.open(url, '_blank');
        },
        createGiftcard_clicked: function(composition) {
            this.$refs.boncadeauPopin.popin_boncadeauDisplayed(composition);
        },
        createGiftcards_clicked: function() {
            this.$refs.bonscadeauxPopin.popin_bonscadeauxDisplayed();
        },
        giftcardItem_clicked: function(giftcard) {
            this.selectedGiftcard = giftcard;
        },
        loadGiftcards: function() {
            axios.get('https://api.lockquest.fr/gift_cards')
                .then((response) => {
                    this.giftcards = response.data.items;
                });
        },
        bonsCadeauxItem_onDeleteClicked: function(giftcard) {
            var ok = window.confirm('Voulez-vous vraiment supprimer le bon cadeau ' + giftcard.code + ' ?');
            if (ok) {
                var token = localStorage.getItem('admin-token');
                axios.post('https://api.lockquest.fr/gift_card', {
                    action: 'delete',
                    data: {
                        code: giftcard.code
                    }
                }, {
                    headers: {
                        'Authorization': `Basic ` + token,
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                }).then((response) => {
                    document.location.reload();
                }).catch((error) => {
                    alert('Une erreur est survenue, merci de contacter notre équipe.');
                });
            }
        }
    },
    mounted() {
        this.loadGiftcards();
    }
}
</script>